import { useMutation, useQueryClient } from 'react-query';
import { addRosterFunctions } from 'RestAPIs/roster/functions';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

type AddRosterFunctionVariables = {
  costCenterId: number;
  functionId: number;
};

const useAddRosterFunctions = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, AddRosterFunctionVariables>(
    ({ costCenterId, functionId }) =>
      addRosterFunctions(costCenterId, functionId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([
          'rosterFunctions',
          'list',
          variables.costCenterId
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddRosterFunctions;
